import React, { useState } from 'react';
import { Plus, Edit2, Trash2 } from 'lucide-react';
import { useApp } from '../../context/AppContext';
import DataTable from '../../components/common/DataTable';
import Modal from '../../components/common/Modal';
import { generateId } from '../../utils/helpers';

function SubjectList() {
  const { subjects, staff, saveSubject, updateSubject, deleteSubject } = useApp();
  const [modal, setModal] = useState(false);
  const [form, setForm] = useState({ name:'', code:'', teacherId:'', maxMarks:'100', passingMarks:'33', isOptional:false });
  const [editing, setEditing] = useState(null);

  const openAdd = () => { setForm({ name:'', code:'', teacherId:'', maxMarks:'100', passingMarks:'33', isOptional:false }); setEditing(null); setModal(true); };
  const openEdit = (s) => { setForm(s); setEditing(s); setModal(true); };
  const remove = async (id) => { if(window.confirm('Delete subject?')) await deleteSubject(id); };
  const save = async () => {
    if (editing) await updateSubject(editing.id, {...form,id:editing.id,classIds:editing.classIds||[]});
    else await saveSubject({...form,id:generateId('SUB'),classIds:[]});
    setModal(false);
  };

  const getTeacher = (id) => { const s=staff.find(s=>s.id===id); return s?`${s.firstName} ${s.lastName}`:'-'; };

  const columns = [
    { label: 'Subject', key:'sub', searchValue: s=>`${s.name||''} ${s.code||''}`, render: s=><div><p className="font-semibold">{s.name}</p><p className="">{s.code}</p></div> },
    { label: 'Teacher', key:'teacher', searchValue: s=>getTeacher(s.teacherId), render: s=>getTeacher(s.teacherId) },
    { label: 'Max Marks', accessor:'maxMarks' },
    { label: 'Pass Marks', accessor:'passingMarks' },
    { label: 'Optional', key:'opt', searchValue: s=>s.isOptional?'optional':'compulsory', render: s=>s.isOptional?<span className="bg-yellow-100 text-yellow-700 px-2 py-0.5 rounded-full">Optional</span>:<span className="bg-green-100 text-green-700 px-2 py-0.5 rounded-full">Compulsory</span> },
  ];

  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <div><h1 className="text-2xl font-bold">Subjects</h1><p className="text-gray-500 text-sm">{subjects.length} subjects</p></div>
        <button onClick={openAdd} className="flex items-center gap-2 bg-purple-600 hover:bg-purple-700 text-white px-4 py-1 rounded-lg text-sm font-medium"><Plus size={16}/>Add Subject</button>
      </div>
      <DataTable columns={columns} data={subjects}
        actions={row=><>
          <button onClick={()=>openEdit(row)} className="p-1.5 hover:bg-purple-50 rounded-lg text-purple-600"><Edit2 size={15}/></button>
          <button onClick={()=>remove(row.id)} className="p-1.5 hover:bg-red-50 rounded-lg text-red-500"><Trash2 size={15}/></button>
        </>}
      />
      <Modal isOpen={modal} onClose={()=>setModal(false)} title={editing?'Edit Subject':'Add Subject'}>
        <div className="space-y-3">
          {[['Subject Name','name','text'],['Code','code','text'],['Max Marks','maxMarks','number'],['Passing Marks','passingMarks','number']].map(([label,key,type])=>(
            <div key={key}>
              <label className="block text-sm font-medium mb-1">{label}</label>
              <input type={type} value={form[key]||''} onChange={e=>setForm(f=>({...f,[key]:e.target.value}))}
                className="w-full px-3 py-1 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-purple-300" />
            </div>
          ))}
          <div>
            <label className="block text-sm font-medium mb-1">Teacher</label>
            <select value={form.teacherId||''} onChange={e=>setForm(f=>({...f,teacherId:e.target.value}))} className="w-full px-3 py-1 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-purple-300">
              <option value="">Select Teacher</option>
              {staff.map(s=><option key={s.id} value={s.id}>{s.firstName} {s.lastName}</option>)}
            </select>
          </div>
          <div className="flex items-center gap-2">
            <input type="checkbox" checked={!!form.isOptional} onChange={e=>setForm(f=>({...f,isOptional:e.target.checked}))} className="w-4 h-4 accent-indigo-600" />
            <label className="text-sm">Optional Subject</label>
          </div>
        </div>
        <div className="flex justify-end gap-2 mt-4 pt-4 border-t">
          <button onClick={()=>setModal(false)} className="px-4 py-1 text-sm hover:bg-gray-100 rounded-lg">Cancel</button>
          <button onClick={save} className="px-4 py-1 text-sm bg-purple-600 text-white rounded-lg hover:bg-purple-700">Save</button>
        </div>
      </Modal>
    </div>
  );
}
export default SubjectList;
